import { render, staticRenderFns } from "./Show-atendimento-empresa.vue?vue&type=template&id=d38a97ce&"
import script from "./Show-atendimento-empresa.vue?vue&type=script&lang=js&"
export * from "./Show-atendimento-empresa.vue?vue&type=script&lang=js&"
import style0 from "./Show-atendimento-empresa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports